function Distributor(data){
	this.data = data;//TODO: should not go in a seperate object
	this.travelInfoParsed = false;
	this.distanceMatrixService = new google.maps.DistanceMatrixService();

	// TODO: use of a global variable is not recommended
	this.locale = (typeof ig_current_locale !== 'undefined' ? ig_current_locale : 'en_GB');// TODO: default should go to US?

	this.createListItem = this.createListItem.bind(this);
}

// TODO: could use a refactor
Distributor.prototype.createListItem = function(currentLocation){
	var listItemElement = document.createElement('li');
	listItemElement.setAttribute('class', 'search-distributors-list-item');

	listItemElement.classList.add('search-distributors-list-item-type-' + this.data.type.toLowerCase().replace(/\s/g, '-'));

	const linkElement = document.createElement('a');
	let link = this.data.website;
	if(!link.match(/^https?:\/\//)){
		link = 'http://' + link;
	}
	linkElement.setAttribute('href', link);

	const view = {
		'name': this.data.name,
		'street': this.data.address.street,
		'houseNumber': this.data.address.houseNumber,
		'streetHouseNumber': [this.data.address.street, this.data.address.houseNumber].filter(value => value).join(' '),
		'houseNumberStreet': [this.data.address.houseNumber, this.data.address.street].filter(value => value).join(' '),
		'addresAdditional': this.data.address.addressAdditional,
		'postcode': this.data.postcode,
		'city': this.data.city,
		'postcodeCity': [this.data.postcode, this.data.city].filter(value => value).join(' '),
		'contactInfoAvailable': this.data.phone || this.data.phoneAdditional || this.data.website,
		'phone': this.data.phone,
		'phoneHrefAttribute': this.data.phone.replace(/[^\+\d]/, ''),
		'phoneAdditional': this.data.phoneAdditional,
		'phoneAdditionalHrefAttribute': this.data.phoneAdditional.replace(/[^\+\d]/, ''),
		'website': linkElement.hostname,
		'websiteHrefAttribute': this.data.website
	};

	if (this.data.stockistTypes) {
		view.stockistTypes = this.data.stockistTypes;
		view.stockistTypesAvailable = (this.data.stockistTypes.length);
	}

	listItemElement.innerHTML = this.renderDistributorList(view);

	if(!this.data.travelInfoParsed && currentLocation){
		var distributorLocation = {'lat': this.data.location.latitude, 'lng': this.data.location.longitude};

		let unitSystem = google.maps.UnitSystem.METRIC;
		if(this.locale == 'en_GB'){
			unitSystem = google.maps.UnitSystem.IMPERIAL
		}

		this.distanceMatrixService.getDistanceMatrix({
			origins: [currentLocation],
			destinations: [distributorLocation],
			travelMode: 'DRIVING',
			unitSystem: unitSystem,
		}, function(response, status){
			this.displayTravelInfo(response, status);
		}.bind(this));

	}

	this.domContainer = listItemElement;

	return listItemElement;
};

Distributor.prototype.displayTravelInfo = function(response, status){
	if(status == 'OK' && response.rows[0].elements[0].status == 'OK'){
		var distance = response.rows[0].elements[0].distance.text;
		var duration = response.rows[0].elements[0].duration.text;

		const titleContainer = this.domContainer.querySelector('.distributor-title-container');

		if(titleContainer && titleContainer.nodeType == 1) {
			var travelInfoElement = document.createElement('span');
			travelInfoElement.appendChild(document.createTextNode(distance + ' / ' + duration));
			travelInfoElement.setAttribute('class', 'distributor-travelinfo');
			titleContainer.appendChild(travelInfoElement);
			this.travelInfoParsed = true;
		}
	}
};

// TODO: Where are the methods in this method comming from?
Distributor.prototype.renderDistributorList = function(view){
	switch(this.locale + '-' + this.data.type){
		case 'nl_NL-installer':
			return this.renderInstallerListNl(view);
		case 'nl_NL-merchant':
			return this.renderMerchantListNl(view);
		case 'en_GB-installer':
		default:
			return this.renderInstallerListGb(view);
		case 'en_GB-merchant':
			return this.renderMerchantListGb(view);
	}
};

export default Distributor;